import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-column-fluid" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-body py-4" }
const _hoisted_4 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_5 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "text-center min-w-150px" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "fa-regular fa-comment-dots text-primary"
}
const _hoisted_13 = {
  key: 1,
  class: "fa-regular fa-comment-dots text-secondary"
}
const _hoisted_14 = { class: "d-flex align-items-center" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = ["onClick"]

import { ref, onMounted, inject, provide } from "vue";
import TableFooter from "@/components/TableFooter.vue";
import {
  VerificationStatusTypes,
  VerificationStatus,
} from "@/core/types/VerificationInfos";
import UserService from "../../services/UserService";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import UserVerifyDocModal from "@/projects/tenant/modules/accounts/components/modal/UserVerifyDocModal.vue";
import InjectKeys from "@/core/types/TenantGlobalInjectionKeys";
import { CommentType } from "@/core/types/CommentType";
import jpHeader from "./jpComp/jpHeader.vue";
import jpVerifyModal from "./jpComp/jpVerifyModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'jpVerification',
  setup(__props) {

const userVerifyDocModal = ref<InstanceType<typeof UserVerifyDocModal>>();
const modalRef = ref<any>(null);
const isLoading = ref(true);
const items = ref(Array<any>());
const tab = ref(VerificationStatusTypes.AwaitingReview);
// 74f9f9d
const criteria = ref<any>({
  page: 1,
  size: 10,
  status: tab.value,
  sortField: "UpdatedOn",
});

const openCommentView = inject<
  (type: CommentType, id: number, title: string) => any
>(InjectKeys.OPEN_COMMENT_VIEW, () => null);

const reset = () => {
  criteria.value.email = null;
  fetchData(1);
};

const search = () => {
  criteria.value.status = null;
  fetchData(1);
};

const fetchData = async (selectedPage: number) => {
  criteria.value.page = selectedPage;
  isLoading.value = true;
  try {
    const res = await UserService.queryVerifications(criteria.value);
    items.value = res.data.map((x) => ({
      ...x,
      user: { ...x.user, partyId: x.partyId },
    }));
    criteria.value = res.criteria;
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isLoading.value = false;
  }
};

provide("isLoading", isLoading);
provide("criteria", criteria);
provide("tab", tab);
provide("reset", reset);
provide("search", search);
provide("fetchData", fetchData);

// on mounted, fetch the first page of Awaiting verification users
onMounted(() => {
  fetchData(1);
});

const show = (id) => {
  modalRef.value?.show(id);
};

// const pageChange = (page: number) => {
//   fetchData(page);
// };

return (_ctx: any,_cache: any) => {
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_UserInfo = _resolveComponent("UserInfo")!
  const _component_TimeShow = _resolveComponent("TimeShow")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(jpHeader),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("table", _hoisted_4, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_5, [
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.verificationId")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.client")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.status")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.updatedOn")), 1),
                (
                  criteria.value.status === _unref(VerificationStatusTypes).Approved ||
                  criteria.value.status == null
                )
                  ? (_openBlock(), _createElementBlock("th", _hoisted_6, _toDisplayString(_ctx.$t("fields.operator")), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t("action.action")), 1)
              ])
            ]),
            (isLoading.value)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
                  _createVNode(_component_LoadingRing)
                ]))
              : (!isLoading.value && items.value.length === 0)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                    _createVNode(_component_NoDataBox)
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", null, [
                          _createTextVNode(_toDisplayString(item.id) + " ", 1),
                          (_ctx.$can('Admin'))
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "ms-2 cursor-pointer",
                                role: "button",
                                onClick: ($event: any) => (
                    _unref(openCommentView)(
                      _unref(CommentType).Verification,
                      item.id,
                      item.user?.firstName + ' ' + item.user?.lastName
                    )
                  )
                              }, [
                                (item.hasComment)
                                  ? (_openBlock(), _createElementBlock("i", _hoisted_12))
                                  : (_openBlock(), _createElementBlock("i", _hoisted_13))
                              ], 8, _hoisted_11))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_14, [
                          _createVNode(_component_UserInfo, {
                            user: item.user,
                            class: "me-2"
                          }, null, 8, ["user"])
                        ]),
                        _createElementVNode("td", null, _toDisplayString(_ctx.$t(`status.${_unref(VerificationStatus)[item.status]}`)), 1),
                        _createElementVNode("td", null, [
                          _createVNode(_component_TimeShow, {
                            "date-iso-string": item.updatedOn
                          }, null, 8, ["date-iso-string"])
                        ]),
                        (
                  criteria.value.status == null ||
                  item.status === _unref(VerificationStatusTypes).Approved
                )
                          ? (_openBlock(), _createElementBlock("td", _hoisted_15, [
                              (item.operator)
                                ? (_openBlock(), _createBlock(_component_UserInfo, {
                                    key: 0,
                                    user: item.operator,
                                    disableCommentView: true
                                  }, null, 8, ["user"]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("td", _hoisted_16, [
                          (item.status != _unref(VerificationStatusTypes).Incomplete)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "btn btn-light btn-primary btn-sm me-3",
                                onClick: ($event: any) => (show(item.id))
                              }, _toDisplayString(_ctx.$t("action.details")), 9, _hoisted_17))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ]))
          ]),
          _createVNode(TableFooter, {
            onPageChange: fetchData,
            criteria: criteria.value
          }, null, 8, ["criteria"])
        ])
      ])
    ]),
    _createVNode(UserVerifyDocModal, {
      ref_key: "userVerifyDocModal",
      ref: userVerifyDocModal,
      onUserApproved: _cache[0] || (_cache[0] = ($event: any) => (fetchData(1)))
    }, null, 512),
    _createVNode(jpVerifyModal, {
      ref_key: "modalRef",
      ref: modalRef,
      onFetchData: _cache[1] || (_cache[1] = ($event: any) => (fetchData(1)))
    }, null, 512)
  ], 64))
}
}

})